/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Info Filled Icon component.
 */
const InfoFilledIcon = ({
  color = dlsColor('grey3')
}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.75 0C10.4778 0 13.4998 3.02223 13.5 6.75C13.5 10.4779 10.4779 13.5 6.75 13.5C3.02223 13.4998 0 10.4778 0 6.75C0.000176758 3.02234 3.02234 0.000176758 6.75 0ZM6.75 5.94629C6.33594 5.94575 6 6.28121 6 6.69531V10.749C6 11.1631 6.33594 11.4991 6.75 11.5C7.1641 11.5007 7.49982 11.166 7.5 10.752V6.69824C7.5 6.28403 7.16421 5.94701 6.75 5.94629ZM6.75 3C6.33599 2.99955 6.00009 3.33499 6 3.74902V3.99219C6 4.40629 6.33594 4.74236 6.75 4.74316C7.16405 4.74379 7.49974 4.40911 7.5 3.99512V3.75195C7.5 3.33774 7.16421 3.00063 6.75 3Z' fill={iconColor} />
    </svg>
  );
};

export default React.memo(InfoFilledIcon);
